<!-- src/views/AppLayout.vue -->
<template>
  <div class="layout">
    <!-- 顶部导航栏（包含 Header 和 Nav） -->
    <header class="top-header">
      <div class="header-top">
        <div class="logo">
          <span class="logo-text">N.SHIPS OMS</span>
        </div>
        <div class="header-right">
          <span class="user-info">
            <span class="user-name">{{ displayName }}</span>
            <span class="user-role">{{ deptName }}</span>
          </span>
          <button class="btn-refresh" @click="handleRefresh">⟳ Refresh</button>
          <button class="btn-pwd" @click="handleChangePwd">Change Password</button>
          <button class="btn-nickname" @click="handleChangeNickname">Change Nickname</button>
          <button class="btn-logout" @click="handleLogout">⤿ Logout</button>
        </div>
      </div>
      
      <!-- 水平导航菜单 -->
      <nav class="nav-bar">
        <div 
          v-for="item in navConfig" 
          :key="item.key"
          class="nav-item"
          :class="{ active: currentKey === item.key }"
          @click="handleNavClick(item)"
        >
          {{ item.name }}
        </div>
      </nav>
    </header>

    <!-- 主内容区域（全宽） -->
    <main class="main-content">
      <router-view />
    </main>

    <AppFooter />

    <!-- ===== 修改昵称对话框 ===== -->
    <el-dialog 
      v-model="showNicknameDialog" 
      title="修改昵称" 
      width="420px"
      :close-on-click-modal="false"
    >
      <el-form :model="nicknameForm" label-width="80px">
        <el-form-item label="当前昵称">
          <el-input :value="displayName" disabled />
        </el-form-item>
        <el-form-item label="新昵称">
          <el-input 
            v-model="nicknameForm.nickname" 
            placeholder="请输入新昵称（2-20个字符）"
            maxlength="20"
            show-word-limit
            clearable
            @keypress.enter="submitNickname"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showNicknameDialog = false">取消</el-button>
        <el-button type="primary" @click="submitNickname" :loading="nicknameLoading">
          确认修改
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue'
import { ElMessage } from 'element-plus'

export default {
  name: 'AppLayout',
  components: {
    AppFooter
  },
  data() {
    return {
      deptName: this.getDeptName(),
      userName: localStorage.getItem('username') || '用户',
      realName: localStorage.getItem('realName') || '',
      navConfig: this.getNavConfig(),
      currentKey: '',
      // 修改昵称对话框
      showNicknameDialog: false,
      nicknameLoading: false,
      nicknameForm: {
        nickname: ''
      }
    }
  },
  computed: {
    displayName() {
      return this.realName || this.userName || '用户'
    }
  },
  mounted() {
    // 从 localStorage 读取昵称
    const savedName = localStorage.getItem('realName')
    if (savedName) {
      this.realName = savedName
    }

    const currentPath = this.$route.path
    const item = this.navConfig.find(item => item.path === currentPath)
    if (item) {
      this.currentKey = item.key
    } else if (this.navConfig.length > 0) {
      this.currentKey = this.navConfig[0].key
    }
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        const item = this.navConfig.find(item => item.path === newPath)
        if (item) {
          this.currentKey = item.key
        }
      },
      immediate: true
    }
  },
  methods: {
    getDeptName() {
      const roleMap = {
        management: 'Management Department',
        finance: 'Finance Department',
        market: 'Market Department',
        operation: 'Operation Department'
      }
      const role = localStorage.getItem('userRole') || 'management'
      return roleMap[role] || 'Employee'
    },

    getNavConfig() {
      const role = localStorage.getItem('userRole') || 'management'
      
      const navConfigs = {
        management: [
          { key: 'main', name: 'Main', path: '/management/main' },
          { key: 'vessel', name: 'Management Vessel Inspection', path: '/management/vessel-inspection' },
          { key: 'orders', name: 'Order Monitoring', path: '/management/order-monitor' },
          { key: 'ports', name: 'Port Details', path: '/management/port-details' }
        ],
        finance: [
          { key: 'main', name: 'Main', path: '/finance/main' },
          { key: 'vessel', name: 'Finance Vessel Inspection', path: '/finance/vessel-inspection' },
          { key: 'proceeding', name: 'Finance Monitoring', path: '/finance/proceeding' },
          { key: 'ports', name: 'Port Details', path: '/finance/port-details' }
        ],
        market: [
          { key: 'main', name: 'Main', path: '/market/main' },
          { key: 'ports', name: 'Port Details', path: '/market/port-details' }
        ],
        operation: [
          { key: 'main', name: 'Main', path: '/operation/main' },
          { key: 'monitoring', name: 'Order Monitoring', path: '/operation/order-monitoring' },
          { key: 'ports', name: 'Port Details', path: '/operation/port-details' }
        ]
      }
      
      return navConfigs[role] || navConfigs.management
    },

    handleNavClick(item) {
      this.currentKey = item.key
      this.$router.push(item.path)
    },

    handleRefresh() {
      this.$router.go(0)
    },

    handleChangePwd() {
      this.$router.push('/change-password')
    },

    handleChangeNickname() {
      this.nicknameForm.nickname = ''
      this.showNicknameDialog = true
    },

    async submitNickname() {
      const nickname = this.nicknameForm.nickname.trim()
      
      if (!nickname) {
        ElMessage.warning('请输入新昵称')
        return
      }
      
      if (nickname.length < 2) {
        ElMessage.warning('昵称至少2个字符')
        return
      }
      
      if (nickname.length > 20) {
        ElMessage.warning('昵称最多20个字符')
        return
      }
      
      this.nicknameLoading = true
      
      try {
        const token = localStorage.getItem('token')
        const response = await fetch('http://localhost:3000/api/auth/change-nickname', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ nickname })
        })
        
        const data = await response.json()
        
        if (data.success) {
          ElMessage.success('昵称修改成功！')
          
          // 更新本地存储
          localStorage.setItem('realName', data.data.realName)
          localStorage.setItem('username', data.data.realName)
          
          // 更新显示
          this.realName = data.data.realName
          this.userName = data.data.realName
          
          // 关闭对话框
          this.showNicknameDialog = false
          this.nicknameForm.nickname = ''
        } else {
          ElMessage.error(data.message || '修改失败')
        }
      } catch (error) {
        console.error('修改昵称错误:', error)
        ElMessage.error('修改失败，请稍后重试')
      } finally {
        this.nicknameLoading = false
      }
    },

    handleLogout() {
      localStorage.clear()
      this.$router.push('/login')
      setTimeout(() => window.location.reload(), 150)
    }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f0f2f5;
}

.top-header {
  background: #0a1628;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 56px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
}

.logo-text {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #ffffff 0%, #60a5fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #a0b4c8;
  font-size: 13px;
}

.user-name {
  color: white;
  font-weight: 600;
}

.user-role {
  background: rgba(255,255,255,0.12);
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.header-right button {
  padding: 6px 14px;
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.3s;
  background: rgba(255,255,255,0.06);
  color: #a0b4c8;
}

.header-right button:hover {
  background: rgba(255,255,255,0.12);
  color: white;
}

.btn-logout {
  color: #e74c3c !important;
  border-color: rgba(231,76,60,0.3) !important;
}

.btn-logout:hover {
  background: rgba(231,76,60,0.2) !important;
  color: #ff6b6b !important;
}

.nav-bar {
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 44px;
  gap: 4px;
  background: rgba(255,255,255,0.03);
}

.nav-item {
  padding: 8px 18px;
  color: #8a9caa;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s;
  white-space: nowrap;
}

.nav-item:hover {
  background: rgba(255,255,255,0.08);
  color: #dce4ec;
}

.nav-item.active {
  background: rgba(52, 152, 219, 0.2);
  color: #5dade2;
}

.main-content {
  flex: 1;
  padding: 24px;
  background: #f0f2f5;
  overflow-y: auto;
}

/* 修改昵称对话框样式 */
:deep(.el-dialog) {
  border-radius: 12px;
}

:deep(.el-dialog__header) {
  border-bottom: 1px solid #EBEEF5;
  padding: 20px 24px;
}

:deep(.el-dialog__body) {
  padding: 24px;
}

:deep(.el-dialog__footer) {
  border-top: 1px solid #EBEEF5;
  padding: 16px 24px;
}

:deep(.el-form-item) {
  margin-bottom: 20px;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f5f7fa;
}

@media (max-width: 768px) {
  .header-top {
    flex-wrap: wrap;
    height: auto;
    padding: 12px 16px;
    gap: 8px;
  }
  
  .header-right {
    flex-wrap: wrap;
    gap: 6px;
  }
  
  .header-right button {
    font-size: 12px;
    padding: 4px 10px;
  }
  
  .nav-bar {
    overflow-x: auto;
    padding: 0 12px;
    height: auto;
    flex-wrap: nowrap;
    gap: 2px;
  }
  
  .nav-item {
    font-size: 13px;
    padding: 6px 12px;
    white-space: nowrap;
  }
  
  .main-content {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .logo-text {
    font-size: 14px;
  }
  
  .user-info {
    font-size: 12px;
  }
  
  .nav-item {
    font-size: 12px;
    padding: 4px 10px;
  }
}
</style>